import axios from 'axios';

const getCotacoes = (params) => axios.get('/transportador/solicitacoes-fretes/cotacoes', {
  params,
});
export default {
  getCotacoes,
};
